import {
  STATUS_TYPES,
  StatusKey,
} from "../../../utils/integrationConfigData";

interface StatusBadgeProps {
  status: StatusKey | string;
}

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const statusKey =
    (status as StatusKey) in STATUS_TYPES ? (status as StatusKey) : "notSet";
  const statusMeta = STATUS_TYPES[statusKey];
  const isVerified = statusKey === "verified";

  return (
    <span
      className={`ic-status-badge${isVerified ? " ic-status-verified" : ""}`}
    >
      {statusMeta.label}
    </span>
  );
};

export default StatusBadge;
